import { findNodeByKey } from "../../utils/helpers";
/**
 * The DTOTransformer takes the Data-Transfer-Object IProduct and transforms it to a DO (Domain Object, also called Business Object).
 * @define { DTO } Data Transfer Object. The object that is received, in this case through a REST API response.
 * @define { DO } Domain Object, Business Object. An object that is used within application. In this case an object with key ProductId and value IProduct.
 * @returns { ProductIdDO<IProduct> }
 */
export const DTOTransformer = () => {
    const _transform = (data) => {
        return data.reduce((acc, curr) => {
            var _a;
            const productId = (_a = findNodeByKey("itemNoGlobal", curr)) !== null && _a !== void 0 ? _a : curr.itemId;
            return productId ? Object.assign(Object.assign({}, acc), { [`${productId}`]: curr }) : acc;
        }, {});
    };
    return {
        transform: _transform,
    };
};
